'use strict';

module.exports = function () {
	const url = $('.js-zuora-account-sync').first().data('url');

	if (!url) {
		return;
	}

	$.ajax({
		url: url,
		method: 'POST',
		dataType: 'json'
	});
};
